import { isCoordinatorGroup, getCoordinatorMetricValue } from 'utility/Utils'
import MetricCard from './MetricCard'

const MemberMetrics = ({
  member,
  regionName,
  supplierName,
  selectedMetric,
  onSelectMetric,
}) => {
  const isCoordinator = isCoordinatorGroup(member)

  const detailPercentages = member.detailData?.percentages || {}
  const contractVal = detailPercentages.contract ?? member.onboarding?.contract
  const insuranceVal = detailPercentages.insurance ?? member.onboarding?.insurance
  const minAgeVal = detailPercentages.minimumAge ?? member.onboarding?.minimumAge
  const workHoursVal = detailPercentages.workHours ?? member.wage?.workHours
  const wageAboveMinVal = detailPercentages.wageAboveMinimum ?? member.wage?.wageAboveMinimum
  const paymentLogsVal = detailPercentages.paymentLogs ?? member.wage?.paymentLogs
  const productivityVal = detailPercentages.productivity ?? member.wage?.productivity

  const handleMetricClick = (metricKey, metricLabel, value, category = 'wage') => {
    if (!onSelectMetric) return
    onSelectMetric({
      metricKey,
      metricLabel,
      value,
      category,
      regionName: regionName || 'Homeweavers',
      supplierName: supplierName || '-',
      entityName: member.name,
      entityId: member.id || member.name,
      entityType: 'Member',
      entity: member,
    })
  }

  const isMetricSelected = (metricKey) => {
    return (
      selectedMetric?.entityId === (member.id || member.name) &&
      selectedMetric?.metricKey === metricKey
    )
  }

  return (
    <div
      className="d-flex gap-2"
      style={{
        overflowX: 'auto',
        paddingBottom: '4px',
      }}
    >
      {/* ONBOARDING SECTION */}
      <div
        className="d-flex align-items-center me-3"
        style={{
          minWidth: 'fit-content',
          flex: '0 0 auto',
        }}
      >
        <div
          className="small text-info fw-bold me-2"
          style={{
            writingMode: 'vertical-rl',
            textOrientation: 'mixed',
            minWidth: '20px',
          }}
        >
          ONBOARDING
        </div>
        <div className="d-flex gap-2">
          <MetricCard
            label="Contract"
            value={contractVal}
            isSelected={isMetricSelected('contract')}
            onClick={() =>
              handleMetricClick('contract', 'Contract', contractVal, 'onboarding')
            }
          />
          <MetricCard
            label="Insurance"
            value={insuranceVal}
            isSelected={isMetricSelected('insurance')}
            onClick={() =>
              handleMetricClick('insurance', 'Insurance', insuranceVal, 'onboarding')
            }
          />
          <MetricCard
            label="Min Age"
            value={minAgeVal}
            isSelected={isMetricSelected('minimumAge')}
            onClick={() =>
              handleMetricClick('minimumAge', 'Min Age', minAgeVal, 'onboarding')
            }
          />
        </div>
      </div>

      <div
        className="align-self-stretch"
        style={{
          width: '4px',
          backgroundColor: '#e9ecef',
          margin: '0 8px',
          flex: '0 0 auto',
        }}
      ></div>

      {/* WAGE SECTION */}
      <div
        className="d-flex align-items-center"
        style={{
          minWidth: 'fit-content',
          flex: '0 0 auto',
        }}
      >
        <div
          className="small text-warning fw-bold me-2"
          style={{
            writingMode: 'vertical-rl',
            textOrientation: 'mixed',
            minWidth: '20px',
          }}
        >
          W&amp;P
        </div>
        <div className="d-flex gap-2">
          <MetricCard
            label="Work Hours"
            value={workHoursVal}
            colorType="workingHours"
            isSelected={isMetricSelected('workHours')}
            onClick={() =>
              handleMetricClick(
                'workHours',
                'Work Hours',
                workHoursVal,
              )
            }
          />
          {/* <MetricCard label="No OT" value={member.wage?.noOvertime} /> */}
          <MetricCard
            label="Minimum Wage"
            value={wageAboveMinVal}
            isSelected={isMetricSelected('wageAboveMinimum')}
            onClick={() =>
              handleMetricClick(
                'wageAboveMinimum',
                'Minimum Wage',
                wageAboveMinVal,
              )
            }
          />
          <MetricCard
            label="Payment Logs"
            value={paymentLogsVal}
            isSelected={isMetricSelected('paymentLogs')}
            onClick={() =>
              handleMetricClick(
                'paymentLogs',
                'Payment Logs',
                paymentLogsVal,
              )
            }
          />
          <MetricCard
            label="Productivity"
            value={productivityVal}
            isSelected={isMetricSelected('productivity')}
            onClick={() =>
              handleMetricClick(
                'productivity',
                'Productivity',
                productivityVal,
              )
            }
          />
          {isCoordinator && (
            <>
              <MetricCard
                label="Est. Hours"
                value={getCoordinatorMetricValue(member.wage, 'estimatedHours')}
                suffix="h"
                isSelected={isMetricSelected('estimatedHours')}
                onClick={() =>
                  handleMetricClick(
                    'estimatedHours',
                    'Est. Hours',
                    getCoordinatorMetricValue(member.wage, 'estimatedHours'),
                  )
                }
              />
              <MetricCard
                label="Hourly Wage"
                value={getCoordinatorMetricValue(member.wage, 'hourlyWage')}
                suffix=""
                isSelected={isMetricSelected('hourlyWage')}
                onClick={() =>
                  handleMetricClick(
                    'hourlyWage',
                    'Hourly Wage',
                    getCoordinatorMetricValue(member.wage, 'hourlyWage'),
                  )
                }
              />
            </>
          )}
          {/* <MetricCard label="Capacity" value={member.wage?.capacity} /> */}
        </div>
      </div>
    </div>
  )
}

export default MemberMetrics
